import i18n from '@/i18n';

const localizationRequestInterceptor = function (config: any) {
   config.headers = {
      ...config.headers,
      'Accept-Language': i18n.global.locale.value,
   };

   return config;
};

export { localizationRequestInterceptor };
